import { useState } from "react";
import DashboardLayout from "../../../shared/DashboardLayout";

const AddEditProducts = () => {
  const [formData, setFormData] = useState({
    product_title: "",
    product_amount: "",
    product_date: "",
    product_category: "",
    brand_name: "",
    supplier_name: "",
    product_quantity: "",
    product_size: "",
    add_new_size: "",
    product_quality: "",
    product_invoice_number: "",
    purchased_by: "",
    product_description: "",
    product_payment_method: "cash",
    product_total_amount: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <DashboardLayout>
      <form onSubmit={handleSubmit} className="m-4">
        <h2 className="m-4">New Products</h2>

        <div className="row m-4">
          {/* Product Title */}
          <div className="col-lg-4">
            <label htmlFor="product_title" className="form-label fw-bolder">
              Title <span className="required">*</span>
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <input
              type="text"
              className="form-control"
              name="product_title"
              value={formData.product_title}
              onChange={handleChange}
              required
            />
          </div>

          {/* Product Amount */}
          <div className="col-lg-4">
            <label htmlFor="product_amount" className="form-label fw-bolder">
              Amount
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <input
              type="number"
              className="form-control"
              name="product_amount"
              value={formData.product_amount}
              onChange={handleChange}
              style={{ width: "30%" }}
            />
          </div>

          {/* Paid Date */}
          <div className="col-lg-4">
            <label htmlFor="product_date" className="form-label fw-bolder">
              Paid Date <span className="required">*</span>
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <input
              type="date"
              className="form-control"
              name="product_date"
              value={formData.product_date}
              onChange={handleChange}
              required
            />
          </div>

          {/* Product Category */}
          <div className="col-lg-4">
            <label htmlFor="product_category" className="form-label fw-bolder">
              Material Category <span className="required">*</span>
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <select
              name="product_category"
              className="form-control w-50"
              value={formData.product_category}
              onChange={handleChange}
              required
            >
              <option value="">-- Select --</option>
              <option value="12">EARTH FILLING MITI</option>
              <option value="13">CEMENT</option>
              <option value="14">CRUSH</option>
              <option value="15">SAND</option>
              <option value="16">STEEL BARS SARIA</option>
              <option value="17">SANITARY MATERIAL</option>
              <option value="18">HARDWARE MATERIAL</option>
            </select>
          </div>

          {/* Brand Name */}
          <div className="col-lg-4">
            <label htmlFor="brand_name" className="form-label fw-bolder">
              Brand Name
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <input
              type="text"
              className="form-control"
              name="brand_name"
              value={formData.brand_name}
              onChange={handleChange}
            />
          </div>

          {/* Supplier Name */}
          <div className="col-lg-4">
            <label htmlFor="supplier_name" className="form-label fw-bolder">
              Supplier Name
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <input
              type="text"
              className="form-control"
              name="supplier_name"
              value={formData.supplier_name}
              onChange={handleChange}
            />
          </div>

          {/* Product Quantity */}
          <div className="col-lg-4">
            <label htmlFor="product_quantity" className="form-label fw-bolder">
              Quantity <span className="required">*</span>
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <input
              type="text"
              className="form-control"
              name="product_quantity"
              value={formData.product_quantity}
              onChange={handleChange}
              style={{ width: "20%" }}
              required
            />
          </div>

          {/* Product Size */}
          <div className="col-lg-4">
            <label htmlFor="product_size" className="form-label fw-bolder">
              Size
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <select
              name="product_size"
              className="form-control"
              value={formData.product_size}
              onChange={handleChange}
              style={{ width: "20%" }}
            >
              <option value="">-- Select --</option>
            </select>
            <input
              type="text"
              name="add_new_size"
              value={formData.add_new_size}
              onChange={handleChange}
              className="form-control my-2"
              style={{ width: "40%" }}
            />
            <button className="btn site_btn text-white">Add</button>
          </div>

          {/* Product Quality */}
          <div className="col-lg-4">
            <label htmlFor="product_quality" className="form-label fw-bolder">
              Quality
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <select
              name="product_quality"
              className="form-control"
              value={formData.product_quality}
              onChange={handleChange}
              style={{ width: "20%" }}
            >
              <option value="">-- Select --</option>
              <option value="A">A</option>
              <option value="B">B</option>
              <option value="C">C</option>
            </select>
          </div>

          {/* Supplier Invoice# */}
          <div className="col-lg-4">
            <label
              for="product_invoice_number"
              className="form-label fw-bolder"
            >
              Supplier Invoice#
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <input
              type="text"
              name="product_invoice_number"
              value={formData.product_invoice_number}
              onChange={handleChange}
              className="form-control"
            />
          </div>

          {/* Purchased By */}
          <div className="col-lg-4">
            <label for="purchased_by" className="form-label fw-bolder">
              Purchased By
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <select
              name="purchased_by"
              value={formData.purchased_by}
              onChange={handleChange}
              className="form-control"
              style={{ width: "20%" }}
            >
              <option value="" selected>
                -- Select --
              </option>
              <option value="1">CA Exp</option>
              <option value="2">CEO Exp</option>
              <option value="77">NIL</option>
            </select>
          </div>

          {/* Description */}
          <div className="col-lg-4">
            <label for="product_description" className="form-label fw-bolder">
              Description
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <textarea
              name="product_description"
              value={formData.product_description}
              onChange={handleChange}
              cols="30"
              rows="5"
              className="form-control"
            ></textarea>
          </div>

          {/* Payment Method */}
          <div className="col-lg-4">
            <label
              htmlFor="product_payment_method"
              className="form-label fw-bolder"
            >
              Payment Method <span className="required">*</span>
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <select
              name="product_payment_method"
              className="form-control"
              value={formData.product_payment_method}
              onChange={handleChange}
              style={{ width: "10%" }}
            >
              <option value="cash">Cash</option>
              <option value="bank">Bank</option>
              <option value="others">Others</option>
            </select>
          </div>

          {/* Total Amount */}
          <div className="col-lg-4">
            <label for="product_total_amount" className="form-label fw-bolder">
              Total Amount
            </label>
          </div>
          <div className="col-lg-8 form-group">
            <input
              type="number"
              className="form-control"
              name="product_total_amount"
              value={formData.product_total_amount}
              onChange={handleChange}
              style={{ width: "30%" }}
            />
          </div>

          <div className="col-lg-4">
            <button type="submit" className="btn site_btn text-white">
              Add Product
            </button>
          </div>
        </div>
      </form>
    </DashboardLayout>
  );
};

export default AddEditProducts;
